import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ArticlePolska2026 from "../pages/article/ArticlePolska2026";
import ArticleJakKorzystac from "../pages/article/ArticleJakKorzystac";
import ArticleNajlepszeProdukty from "../pages/article/ArticleNajlepszeProdukty";
import ArticleBezpieczenstwo from "../pages/article/ArticleBezpieczenstwo";
import ArticleOpinie from "../pages/article/ArticleOpinie";
import ArticleWysylka from "../pages/article/ArticleWysylka";
import ArticleOszustwa from "../pages/article/ArticleOszustwa";
import ArticleVsPandabuy from "../pages/article/ArticleVsPandabuy";
import ArticlePoczatkujacy from "../pages/article/ArticlePoczatkujacy";
import PoradnikZakupowy from "../pages/article/PoradnikZakupowy";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/co-to-jest-kakobuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-polska-2026",
    element: <ArticlePolska2026 />,
  },
  {
    path: "/artykul/jak-korzystac-z-kakobuy-spreadsheet",
    element: <ArticleJakKorzystac />,
  },
  {
    path: "/artykul/najlepsze-produkty-kakobuy",
    element: <ArticleNajlepszeProdukty />,
  },
  {
    path: "/artykul/czy-kakobuy-jest-bezpieczny",
    element: <ArticleBezpieczenstwo />,
  },
  {
    path: "/artykul/opinie-uzytkownikow-kakobuy",
    element: <ArticleOpinie />,
  },
  {
    path: "/artykul/koszty-wysylki-kakobuy",
    element: <ArticleWysylka />,
  },
  {
    path: "/artykul/jak-uniknac-oszustw-kakobuy",
    element: <ArticleOszustwa />,
  },
  {
    path: "/artykul/kakobuy-vs-pandabuy",
    element: <ArticleVsPandabuy />,
  },
  {
    path: "/artykul/poradnik-poczatkujacego-kakobuy",
    element: <ArticlePoczatkujacy />,
  },
  {
    path: "/poradnik-zakupowy",
    element: <PoradnikZakupowy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;